import React, { Component } from 'react';
import classnames from 'classnames';

import $ from 'jquery';
import 'bootstrap';

class CollapsableMenuItem extends Component {
  static defaultProps = {
    icon: 'cog',
  };

  state = { opened: false, show: false };
  element = null;

  componentWillMount = () => this.props.opened && this.setState({ opened: true, show: true });

  handleClick = (e) => {
    e.preventDefault();
    this.setState({ show: !this.state.show });
    this.props.handleToggle(this.state.show);
    $(this.element).collapse('toggle');
  };

  componentDidMount = () => {
    $(this.element).collapse({ toggle: false });
  };

  render = () => (
    <li>
      <a onClick={this.handleClick}>
        <i className={`fa fa-${this.props.icon} fa-lg`} />
        {this.props.label}
        <i
          className={classnames('pull-right fa fa-lg', {
            'fa-angle-up': this.state.show,
            'fa-angle-down': !this.state.show,
          })}
        />
      </a>
      <div
        className={classnames('collapse', { show: this.state.opened })}
        ref={(element) => (this.element = element)}
      >
        {this.props.children}
      </div>
    </li>
  );
}

export default CollapsableMenuItem;



// WEBPACK FOOTER //
// src/modules/secured/components/layout/menu/CollapsableMenuItem.js